
import { numberFunctionHelpers } from "./numberHelpers";

/**
 * Formatea un numero a peso chileno ejemplo: formatterPeso.format(20000) -> resultado $20.000
 */
 const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0
  });

  const formatterDolar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  
  /**
   * Quita el formato de peso chileno a un número
   * @param {*} value 
   * @returns 
   */
  const unformatPeso = (value) => {
    if (value) {
      let newValue = value.replace(/\./g, '');
      newValue = newValue.replace(/\$/g, '');
      if(numberFunctionHelpers.isNumeric(newValue))
        return newValue;
      return null; 
    }
    return null;
  }

  export const currencyFunctionHelpers = {
    formatterPeso: formatterPeso,
    formatterDolar: formatterDolar,
    unformatPeso: unformatPeso
  }